
    import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
    import moment from 'moment';
    import * as firebase from 'firebase';
    import ImageUploader from 'vue-image-upload-resize';
    import utility from '@/utility/utility';
    import commentServices from '@/services/comment-services';
    import { Comment } from '@/models/comment';
    import { APP_CONFIG } from '@/config/app-config'
    import Loading from 'vue-loading-overlay';
    @Component({
        components: {
            ImageUploader,
            Loading
        }
    })
    export default class ChatBox extends Vue {
        @Prop({default: 0})
        private orderId!: number;

        @Prop({default: 1})
        private orderType!: number;
        private hasImage = false;
        private imageData: any = null;
        private uploadValue = 100;
        private comment: string = '';
        private listComment: Comment[] = [];
        private timer: any;

        private isBlockEnter = false;

        get userInfo() {
            return this.$store.state[APP_CONFIG.stateKey.authStore].userInfo;
        }

        private async created() {
            this.timer = setInterval(() => {
                this.loadComment();
            }, APP_CONFIG.notifyRefreshTime * 1000);
        }

        private async destroyed() {
            clearInterval(this.timer);
        }

        @Watch('orderId', { immediate: true, deep: true })
        private async loadComment() {
            if (this.orderId > 0) {
                const result: any = await commentServices.getComment(this.orderId, this.orderType);
                if(result && result.data.status === 200 && result.data.message === 'Success') {
                    const arrComment: any = [];
                    for (const item of result.data.data) {
                        arrComment.push({
                            ...item,
                            CreatedDate: moment(item.CreatedDate).format('DD-MM-YYYY hh:mm:ss')
                        });
                    }

                    this.listComment = arrComment;
                }
                this.setScroll();
            }
        }

        private onCommentKeyup(e: any) {
            if(e.keyCode === 13) {
                e.preventDefault();
                this.addComment();
            }
        }
        
        private async addComment() {
            if (this.comment.trim().length > 0 && this.isBlockEnter === false) {
                this.isBlockEnter = true;
                const commentModel: Comment = {
                    OrderID: this.orderId,
                    Comment: this.comment,
                    Status: 1,
                    Type: 1,
                    OrderType: this.orderType,
                    CustomerID: this.$store.state[APP_CONFIG.stateKey.authStore].userInfo.userId
                };
                const result = await commentServices.addComment(commentModel);
                this.comment = '';
                this.isBlockEnter = false;
                if (result.data.status === 200) {
                    this.loadComment();
                }
            }
        }

        private setScroll() {
            setTimeout(() => {
                const boxMess: any = this.$el.querySelector('.content-message');
                boxMess.scrollTop = boxMess.scrollHeight;
            }, 0);
        }

        private async addFile(output) {
            if(this.uploadValue === 100) {
                this.uploadValue = 0;
                this.hasImage = true;
                this.imageData = output;
                this.onUpload();
            }
        }

        private async onUpload() {
            const arrFileType = this.imageData.info.name.split('.');
            const base64Response = await fetch(this.imageData.dataUrl);
            const blob = await base64Response.blob();
            const storageRef=firebase.storage().ref(`${APP_CONFIG.settings.firebase_prefix}/${utility.randomString(35)}.${arrFileType[arrFileType.length - 1]}`).put(blob);
            storageRef.on(`state_changed`, snapshot => {
                    this.uploadValue = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
                }, error => {
                    Vue.notify({
                        group: 'foo',
                        type: 'error',
                        title: 'Thông báo!',
                        text: 'File ảnh chỉ được tối đa 1Mb!',
                    });
                    this.isBlockEnter = false;
                },
                () => {
                    this.uploadValue=100;
                    storageRef.snapshot.ref.getDownloadURL().then(async (url) => {
                        const commentModel: Comment = {
                            OrderID: this.orderId,
                            Comment: url,
                            Status: 1,
                            Type: 1,
                            OrderType: this.orderType,
                            CustomerID: this.$store.state[APP_CONFIG.stateKey.authStore].userInfo.userId,
                            Media: 1
                        };
                        const result = await commentServices.addComment(commentModel);
                        this.comment = '';
                        this.isBlockEnter = false;
                        if (result.data.status === 200) {
                            this.loadComment();
                        }
                    });
                }
            );
        }

        private async onPaste(event) {
            const clipboardData = event.clipboardData || window['clipboardData'];
            const items = clipboardData.items;
            for (const item of items) {
                if (item.type.indexOf('image') !== -1) {
                    this.isBlockEnter = true;
                    const imageFile = item.getAsFile();
                    const reader = new FileReader();
                    reader.onload = (e) => {
                        if(e.target) {
                            const file = {'dataUrl': e.target.result, 'info': {'name': imageFile.name}};
                            this.addFile(file);
                        }
                    }
                    reader.readAsDataURL(imageFile);
                }
            }
        }
    }
